"use client";

import { PAGES } from "@idss/libraries";
import { Button, Container, Stack, Text, Title } from "@mantine/core";
import { Metadata } from "next";
import { useRouter } from "next/navigation";

// export const metadata: Metadata = {
//   title: "404 - Page Not Found | IDSS",
//   description: "The page you are looking for could not be found.",
// };

export default function NotFound() {
  const router = useRouter();

  return (
    <Container className="flex items-center justify-center min-h-screen">
      <Stack align="center" gap="xl">
        <div className="text-8xl">🔍❓</div>

        <Title order={1} className="text-4xl font-bold text-primary">
          Oops! Page Not Found
        </Title>

        <Text className="max-w-md text-center text-gray-600">
          The page you are looking for might have been removed, had its name
          changed, or is temporarily unavailable.
        </Text>

        <Button
          onClick={() => router.push(PAGES.DASHBOARD)}
          size="lg"
          className="mt-4"
        >
          Return Home
        </Button>
      </Stack>
    </Container>
  );
}
